import { render } from "./evaluationAdd.vue?vue&type=template&id=2283467a&scoped=true"
import script from "./evaluationAdd.vue?vue&type=script&lang=js"
export * from "./evaluationAdd.vue?vue&type=script&lang=js"

import "./evaluationAdd.vue?vue&type=style&index=0&id=2283467a&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2283467a"]])

export default __exports__